var _mask, _path, _mask2, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOverviewLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_10930_25514",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 13C20 14.78 19.4722 16.5201 18.4832 18.0001C17.4943 19.4802 16.0887 20.6337 14.4442 21.3149C12.7996 21.9961 10.99 22.1743 9.24419 21.8271C7.49836 21.4798 5.89471 20.6226 4.63604 19.364C3.37737 18.1053 2.5202 16.5016 2.17293 14.7558C1.82567 13.01 2.0039 11.2004 2.68508 9.55585C3.36627 7.91131 4.51983 6.50571 5.99987 5.51677C7.47991 4.52784 9.21997 4 11 4V13H20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 13C20 14.78 19.4722 16.5201 18.4832 18.0001C17.4943 19.4802 16.0887 20.6337 14.4442 21.3149C12.7996 21.9961 10.99 22.1743 9.24419 21.8271C7.49836 21.4798 5.89471 20.6226 4.63604 19.364C3.37737 18.1053 2.5202 16.5016 2.17293 14.7558C1.82567 13.01 2.0039 11.2004 2.68508 9.55585C3.36627 7.91131 4.51983 6.50571 5.99987 5.51677C7.47991 4.52784 9.21997 4 11 4V13H20Z",
    stroke: "#02B27F",
    strokeWidth: 4,
    mask: "url(#path-1-inside-1_10930_25514)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_10930_25514",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2C14.1819 2 15.3522 2.23279 16.4442 2.68508C17.5361 3.13738 18.5282 3.80031 19.364 4.63604C20.1997 5.47177 20.8626 6.46392 21.3149 7.55585C21.7672 8.64778 22 9.8181 22 11L13 11V2Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2C14.1819 2 15.3522 2.23279 16.4442 2.68508C17.5361 3.13738 18.5282 3.80031 19.364 4.63604C20.1997 5.47177 20.8626 6.46392 21.3149 7.55585C21.7672 8.64778 22 9.8181 22 11L13 11V2Z",
    stroke: "#F2AE00",
    strokeWidth: 4,
    mask: "url(#path-2-inside-2_10930_25514)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverviewLight);
export default __webpack_public_path__ + "static/media/overviewLight.af00335e8e80000733667b1ab78349dd.svg";
export { ForwardRef as ReactComponent };